<template>
  <mobile-responsive-shell title="Achats à valider">
    <div class="pur-noticed">
      <div class="pur-noticed-toolbar">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click="$router.push({ name: 'mobile-sales-create' })"
        >
          <i class="bi bi-plus-square"></i> Créer
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="refresh">
          <i class="bi bi-arrow-clockwise"></i> Actualiser
        </button>
      </div>

      <p v-if="!filteredSales.length" class="text-muted text-center py-4">
        Aucune entrée.
      </p>

      <article
        v-for="(sale, idx) in filteredSales"
        :key="sale.reference || idx"
        class="pur-noticed-card"
      >
        <header class="pur-noticed-head">
          <button
            type="button"
            class="btn btn-link btn-sm p-0 text-start"
            @click="
              $router.push({
                name: 'mobile-sales-details',
                params: { reference: sale.reference },
              })
            "
          >
            {{ sale.reference }}
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="
              $router.push({
                name: 'mobile-sales-details',
                params: { reference: sale.reference },
              })
            "
          >
            <i class="bi bi-info-square"></i>
          </button>
        </header>
        <div class="pur-noticed-meta">
          <span v-if="sale.customer">{{ sale.customer.fullName }}</span>
          <span class="text-muted"> · {{ sale.date }}</span>
        </div>
        <div class="text-warning small">M. {{ sale.totalPriceTTC }}</div>
        <div v-if="sale.user" class="small text-muted">Par {{ sale.user.name }}</div>
        <div v-if="sale.remark" class="pur-noticed-remark small">{{ sale.remark }}</div>
      </article>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";

export default {
  name: "MobilePurchasesToValidate",
  components: { MobileResponsiveShell },
  computed: {
    ...mapGetters("sale", { sales: "getAll" }),
    filteredSales() {
      if (!this.sales || !this.sales.length) return [];
      return this.sales.filter((p) => p.remark != "");
    },
  },
  mounted() {
    this.$store.dispatch("sale/getAll");
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("sale/getAll");
    },
  },
};
</script>

<style scoped>
.pur-noticed-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.pur-noticed-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  margin-bottom: 0.65rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.pur-noticed-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}
.pur-noticed-meta {
  font-size: 0.9rem;
  margin: 0.35rem 0;
}
.pur-noticed-remark {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
  color: #856404;
}
</style>
